import { es } from 'date-fns/locale';
const { format, set, setDate, isSameDay } = require('date-fns');

// obtener rango de quincenas del mes
const getCurrentFortnight = (today, monthStart, monthEnd) => {
    const dayOfMonth = today.getDate();

    if (dayOfMonth <= 15) // primera quincena
        return {
            startRange: monthStart,
            endRange: set(monthStart, { 
                date: 15, hours: 23, minutes: 59, seconds: 59, milliseconds: 999 
            })
        };
    
    return {
        startRange: setDate(monthStart, 16),
        endRange: monthEnd
    };
};

const formatRange = (startDate, endDate) => {
    if (!startDate || !endDate) return '';
    
    if (isSameDay(startDate, endDate))
        return format(startDate, "d/MMMM/yyyy", { locale: es });

    const start = format(startDate, "d/MMMM/yyyy", { locale: es });
    const end = format(endDate, "d/MMMM/yyyy", { locale: es });
    
    return `${start} - ${end}`;
};

export {
    getCurrentFortnight, formatRange
};